import { debug } from 'freedom-shared';

export const bloomreachDebug = (...args: Array<unknown>) => {
  debug('Bloomreach', ...args);
};
